import React from "react";
import { Form, DatePicker, Checkbox, Space, Divider } from "antd";
import dayjs from "dayjs";

const LicenseSettingsStep: React.FC = () => {
  return (
    <div>
      <Form.Item label="Expiry Date" name="expiryDate">
        <DatePicker
          style={{ width: "100%" }}
          format="YYYY-MM-DD"
          disabledDate={(current) =>
            current && current < dayjs().startOf("day")
          }
        />
      </Form.Item>

      <Divider orientation="left">License Settings</Divider>
      <Form.Item label="Feature Settings">
        <Space direction="vertical">
          <Form.Item name="allowBetaFeatures" valuePropName="checked" noStyle>
            <Checkbox>Allow Beta Features</Checkbox>
          </Form.Item>
          <Form.Item name="allowEmbeddedServer" valuePropName="checked" noStyle>
            <Checkbox>Allow Embedded Server</Checkbox>
          </Form.Item>
          <Form.Item name="allowLicensePicker" valuePropName="checked" noStyle>
            <Checkbox>Allow License Picker</Checkbox>
          </Form.Item>
          <Form.Item name="isDevModeEnabled" valuePropName="checked" noStyle>
            <Checkbox>Dev Mode Enabled</Checkbox>
          </Form.Item>
          <Form.Item name="isNonProduction" valuePropName="checked" noStyle>
            <Checkbox>Non Production</Checkbox>
          </Form.Item>
          <Form.Item name="isOem" valuePropName="checked" noStyle>
            <Checkbox>OEM</Checkbox>
          </Form.Item>
          <Form.Item name="isTrial" valuePropName="checked" noStyle>
            <Checkbox>Trial</Checkbox>
          </Form.Item>
          <Form.Item name="isTimeLimit" valuePropName="checked" noStyle>
            <Checkbox>Time Limit</Checkbox>
          </Form.Item>
          <Form.Item name="isOfflineKey" valuePropName="checked" noStyle>
            <Checkbox>Offline Key</Checkbox>
          </Form.Item>
          <Form.Item name="isRestrictedTrial" valuePropName="checked" noStyle>
            <Checkbox>Restricted Trial</Checkbox>
          </Form.Item>
        </Space>
      </Form.Item>
    </div>
  );
};

export default LicenseSettingsStep;

